import { useAppSelector } from "@/app/hooks";
import { AdminLayout } from "@/layouts/AdminLayout";
import { OperationalLayout } from "@/layouts/OperationalLayout";

export function StaffLayout() {
  const user = useAppSelector((state) => state.auth.user);

  if (user?.role === "admin") {
    return <AdminLayout />;
  }

  return <OperationalLayout />;
}
